import { useEffect } from 'react';

type SchemaOrgProps = {
  type: 'WebSite' | 'Organization' | 'WebPage' | 'Article' | 'FAQPage' | 'CollectionPage';
  data?: Record<string, unknown>;
};

const baseSchema = {
  Organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫漫画网',
    url: 'https://bluefocugroup.cn',
    description: '韩漫漫画网提供免费韩国漫画，韩漫大全无删减下拉式内容，完整呈现原版故事，画质优良。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@bluefocugroup.cn',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  },
  WebSite: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫漫画网',
    url: 'https://bluefocugroup.cn',
    description: '免费韩国漫画在线阅读平台，韩漫大全无删减下拉式内容。',
    inLanguage: 'zh-Hans',
  },
};

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const existingScript = document.getElementById(`schema-${type}`);
    if (existingScript) {
      existingScript.remove();
    }

    let schemaContent: Record<string, unknown>;

    if (type === 'Organization' || type === 'WebSite') {
      schemaContent = baseSchema[type];
    } else if (type === 'WebPage') {
      schemaContent = {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        ...data,
      };
    } else if (type === 'CollectionPage') {
      schemaContent = {
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        ...data,
      };
    } else if (type === 'Article') {
      schemaContent = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        ...data,
      };
    } else if (type === 'FAQPage') {
      schemaContent = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        ...data,
      };
    } else {
      return;
    }

    const script = document.createElement('script');
    script.id = `schema-${type}`;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaContent);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(`schema-${type}`);
      if (s) s.remove();
    };
  }, [type, data]);

  return null;
}